import type { AnyObject } from '$util/types';

interface BaseContentComponentConfig {
  lazyLoadImages: boolean;
  preloadImages: boolean;
  tabletOrder?: number;
  desktopOrder?: number;
  widescreenOrder?: number;
}

interface DefaultContentComponentConfig extends BaseContentComponentConfig {
  [key: string]: unknown;
}

export function makeContentComponentDefaultConfig(config?: AnyObject): DefaultContentComponentConfig {
  return {
    lazyLoadImages: true,
    preloadImages: false,
    ...config,
  };
}
